module.exports = __webpack_public_path__ + "static/img/order-dsh.68ea24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order-dsh.png
// module id = c4Bq
// module chunks = 1